export default {
    app: {
        title: "جعبه لغات رؤیایی",
        language: "فارسی"
    },
    pages: {
        app: {
            myAccount: "حساب کاربری من",
            editProfile: "ویرایش پروفایل",

            boxScenarios: "سناریوهای جعبه‌ها",
            scenario1Title: "جعبه نیم‌روزی",
            scenario1Desc: "این جعبه هر نیم‌روز یک‌بار مرور می‌شود (مثلاً صبح و عصر).",

            scenario2Title: "جعبه روزانه",
            scenario2Desc: "این جعبه روزی یک‌بار مرور می‌شود.",

            scenario3Title: "بر اساس شماره جعبه",
            scenario3Desc: "فاصله مرور بر اساس شماره جعبه است (مثلاً جعبه ۳ هر ۳ روز یک‌بار).",

            username: "نام کاربری",
            usernameHint: "نام کاربری یکتای شما برای ورود",

            name: "نام",
            nameHint: "دوست دارید شما را با چه نامی صدا کنیم؟",

            email: "آدرس ایمیل",
            emailHint: "ایمیل برای بازیابی رمز عبور (اختیاری)",

            changePassword: "تغییر رمز عبور",
            changePasswordHint: "اگر نمی‌خواهید رمز عبور را تغییر دهید، این فیلد را خالی بگذارید (اختیاری)",

            logout: "خروج",
            confirmLogout: "تأیید خروج",
            confirmLogoutText: "آیا مطمئن هستید که می‌خواهید خارج شوید؟",
            cancel: "انصراف",

            updateProfile: "به‌روزرسانی پروفایل",

            myWords: "کلمات من",
            addNewWord: "افزودن کلمه/اصطلاح جدید",
            boxes: "جعبه‌ها",

            applicationSettings: "تنظیمات برنامه",

            autoSpeechOnChecking: "پخش خودکار تلفظ هنگام نمایش کلمه",
            autoDetectClipboardChange: "تشخیص خودکار تغییرات کلیپ‌بورد",

            clipboardPermissionText: "برنامه برای دسترسی به کلیپ‌بورد به مجوز در تنظیمات مرورگر نیاز دارد. برای راهنمایی بیشتر اینجا کلیک کنید.",

            clipboardHelpTitle: "نحوه فعال‌سازی دسترسی به کلیپ‌بورد",

            chrome: "کروم",
            firefox: "فایرفاکس",
            safari: "سافاری",

            chromeStep1: "مرورگر Chrome را باز کنید.",
            chromeStep2: "به تنظیمات مرورگر بروید.",
            chromeStep3: "بخش Site Settings یا Settings را پیدا کنید.",
            chromeStep4: "به بخش Permissions بروید و Clipboard را فعال کنید.",

            firefoxStep1: "مرورگر Firefox را باز کنید.",
            firefoxStep2: "به تنظیمات مرورگر بروید.",
            firefoxStep3: "بخش Permissions را پیدا کرده و دسترسی به کلیپ‌بورد را فعال کنید.",

            safariStep1: "برنامه Settings گوشی خود را باز کنید.",
            safariStep2: "به بخش Safari بروید.",
            safariStep3: "تنظیمات مربوط به کلیپ‌بورد را پیدا کرده و فعال کنید.",

            otherBrowserTitle: "اگر از مرورگر دیگری استفاده می‌کنید",
            otherBrowserStep1: "در تنظیمات مرورگر گزینه‌ای مشابه Permissions یا Site Settings را پیدا کرده و دسترسی به کلیپ‌بورد را فعال کنید.",

            speechNotSupported: "مرورگر شما از SpeechSynthesis پشتیبانی نمی‌کند",

            ttsSettings: "تنظیمات تبدیل متن به گفتار",
            sampleText: "متن برای تست تلفظ",

            rate: "سرعت",
            rateHint: "سرعت پخش گفتار را کنترل می‌کند.",

            pitch: "زیر و بمی صدا",
            pitchHint: "زیر و بمی صدا را تنظیم می‌کند.",

            volume: "بلندی صدا",
            volumeHint: "بلندی صدای گفتار را تنظیم می‌کند.",

            friends: "دوستان",
            messages: "پیام‌ها",

            addToMyWords: "افزودن {word} به کلمات من",
            viewInMyList: "مشاهده {word} در لیست من",

            wordSuggestion: "پیشنهاد کلمه",
            goToAddWord: "رفتن به صفحه افزودن کلمه جدید",

            updateCompleted: "به‌روزرسانی با موفقیت انجام شد",
            latestChanges: "آخرین تغییرات در نسخه‌های اخیر",
            version: "نسخه",
            gotIt: "متوجه شدم"
        },
        addVocabulary: {
            title: "افزودن کلمه جدید",
            add: "افزودن",
            word: "کلمه / عبارت",
            meaning: "معنی",
            example: "مثال",
            description: "توضیحات"
        },
        reviewVocabulary: {
            showMeaning: "نمایش معنی",
            hideMeaning: "پنهان کردن معنی",
            meaning: "معنی",
            example: "مثال",
            description: "توضیحات",
            playPhrase: "PlayPhrase.me",
            prev: "قبلی",
            next: "بعدی"
        },
        vocabularies: {
            searchLabel: "جستجوی کلمه",
            listLength: "تعداد در هر صفحه",
            boxNumber: "شماره جعبه",
            nothingFound: "چیزی پیدا نشد !!!",
            adjustFilters: "لطفاً فیلترهای خود را تغییر دهید",
            tableWord: "کلمه",
            tableAction: "عملیات",
            showDetails: "جزئیات",
            completeInfo: "اطلاعات کامل",
            meaning: "معنی",
            example: "مثال",
            description: "توضیحات",
            close: "بستن",
            editTitle: "ویرایش کلمه",
            editBtn: "ویرایش",
            deleteTitle: "حذف کلمه {word}",
            deleteConfirmText: "آیا از حذف این کلمه اطمینان دارید؟ توجه داشته باشید که بعد از حذف امکان بازیابی وجود ندارد.",
            yes: "بله، حذف شود",
            no: "خیر"
        },
        messages: {
            wordSuggestions: "پیشنهاد کلمات"
        },
        login: {
            signInTitle: "ورود به حساب",
            signInBtn: "ورود",
            registerTitle: "ثبت‌نام",
            registerBtn: "عضویت",
            registerLink: "ثبت‌نام",
            username: "نام کاربری",
            password: "رمز عبور",
            nickname: "نام (لقب)",
            email: "آدرس ایمیل",
            noAccount: "هنوز ثبت‌نام نکرده‌اید؟",
            haveAccount: "قبلاً ثبت‌نام کرده‌ام.",
            usernameHint: "نام کاربری منحصر به فرد برای ورود",
            nicknameHint: "دوست دارید با چه نامی دیده شوید؟",
            emailHint: "ایمیل برای بازیابی رمز عبور (اختیاری)",
            passwordHint: "بدون محدودیت! هر چه دوست دارید وارد کنید",
            orContinueWith: "یا ادامه با...",
            guestRegister: "ثبت‌نام سریع به عنوان مهمان 😒"
        },
        checkVocabulary: {
            showMeaning: "نمایش معنی",
            hideMeaning: "پنهان کردن معنی",
            wordsRemain: "کلمه باقی مانده",
            lastOne: "آخرین مورد",
            meaning: "معنی",
            example: "مثال",
            description: "توضیحات",
            playPhrase: "PlayPhrase.me",
            iRemember: "بلدم",
            iDontRemember: "بلد نیستم"
        },
        boxes: {
            all: "نمایش همه جعبه‌ها",
            box: "جعبه",
            empty: "خالی",
            needsChecking: "نیاز به بررسی",
            checked: "بررسی شده",

            total: "تعداد کل",
            waiting: "در انتظار",
            waitingForCheck: "در انتظار بررسی",

            closestReview: "نزدیک‌ترین مرور",
            notScheduled: "هنوز زمان‌بندی نشده",

            deeplyMemorized: "شما {count} کلمه را به‌خوبی به حافظه سپرده‌اید.",
            notReachedYet: "هنوز به این جعبه نرسیده‌اید.",

            startChecking: "شروع بررسی",
            review: "مرور",
            viewAllWords: "مشاهده همه کلمات",
            addNew: "افزودن کلمه جدید",
            itsEmpty: "خالی است"
        },
        friends: {
            searchInUsers: "جستجو در کاربران",
            searchList: "لیست جستجو",
            noUsersYet: "هنوز کاربری وجود ندارد.",
            searchUsersAndSendRequest: "می‌توانید کاربران را جستجو کرده و درخواست دوستی ارسال کنید",
            friendList: "لیست دوستان",
            noFriendsYet: "هنوز دوستی وجود ندارد."
        }

    },
    plugins: {
        axios: {
            postRequestError: "خطا در ارسال درخواست"
        },

    },
    components: {
        shareButton: {
            shareTitle: "اشتراک‌گذاری {word}",
            messageOptional: "پیام (اختیاری)"
        },
        userList: {
            cancelRequest: "لغو درخواست",
            unfriend: "حذف دوستی",
            sendRequest: "ارسال درخواست",
            accept: "پذیرفتن",
            reject: "رد کردن",

            share: "اشتراک‌گذاری",
            addedBefore: "قبلاً اضافه شده",

            deeplyMemorized: "{name} تعداد {count} کلمه را کاملاً به خاطر سپرده است.",
            notReachedBox: "{name} هنوز به این جعبه نرسیده است.",

            totalVocabularies: "کل واژگان",
            registerAge: "مدت عضویت",
            lastCheck: "آخرین مرور",
            lastAddedVocabulary: "آخرین واژه افزوده شده",
            totalChecks: "تعداد کل مرورها",
            averageDailyCheck: "میانگین مرور روزانه",
            averageDailyLearnedCheck: "میانگین یادگیری روزانه",
            averageDailyNotLearnedCheck: "میانگین عدم یادگیری روزانه",
            averageDailyAdd: "میانگین افزودن روزانه"
        }
    }
    , public: {
        close: "بستن",
    }
    , "apiResultStatusCodes": {
        "0": "عملیات ناموفق بود",
        "1": "عملیات با موفقیت انجام شد",
        "2": "خطایی رخ داد",
        "3": "پارامترهای ارسال شده نامعتبر هستند",
        "4": "یافت نشد",
        "5": "خطای احراز هویت",
        "6": "این آیتم قبلاً ثبت شده است",
        "7": "این کاربر قبلاً ثبت شده است",
        "8": "کاربر مورد نظر وجود ندارد",
        "9": "رمز عبور اشتباه است",
        "10": "پارامترهای ارسال شده نامعتبر هستند",
        "11": "احراز هویت ناموفق بود",
        "12": "دسترسی مجاز نیست",
        "13": "آیتم مورد نظر یافت نشد",
        "14": "این نام کاربری قبلاً انتخاب شده است",
        "15": "این ایمیل قبلاً انتخاب شده است",
        "16": "نام کاربری الزامی است",
        "17": "نام نمایشی الزامی است",
        "18": "رمز عبور الزامی است",
        "19": "نام کاربری نباید فاصله داشته باشد",
        "20": "ثبت‌نام با موفقیت انجام شد",
        "21": "ورود با موفقیت انجام شد",
        "22": "رمز عبور نباید فاصله داشته باشد",
        "23": "لغت با موفقیت اضافه شد",
        "24": "لغت با موفقیت ویرایش شد",
        "25": "لغت با موفقیت حذف شد",
        "26": "این لغت قبلاً اضافه شده است",
        "27": "وارد کردن کلمه الزامی است",
        "28": "هیچ لغتی یافت نشد",
        "29": "تبریک! همه لغات این جعبه بررسی شده‌اند",
        "30": "امکان تغییر فیلد کلمه وجود ندارد",
        "31": "لطفاً فیلدهای الزامی را تکمیل کنید",
        "32": "هیچ تغییری در درخواست شما یافت نشد",
        "33": "کاربر مورد نظر در مخزن یافت نشد",
        "34": "درخواست دوستی با موفقیت ارسال شد",
        "35": "درخواست دوستی با موفقیت پذیرفته شد",
        "36": "درخواست دوستی با موفقیت لغو شد",
        "37": "دوستی با موفقیت حذف شد",
        "38": "درخواست دوستی با موفقیت رد شد",
        "39": "پیام با موفقیت ارسال شد"
    },
    "time": {
        "day": "روز",
        "hour": "ساعت",
        "minute": "دقیقه"
    }

}
